<script>
export default {
  inheritAttrs: false,
  props: {
    href: {
      type: String,
      default: '',
    },
    target: {
      type: String,
      default: '_blank',
    },
    allowInsecure: {
      type: Boolean,
      default: false,
    },
    to: {
      type: Object,
      default: null,
    },
    name: {
      type: String,
      default: '',
    },
    params: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    routerLinkTo({ name, params }) {
      return {
        name,
        params,
        ...(this.to || {}),
      }
    },
  },
}
</script>

<template>
  <a v-if="href" :class="$style.linkAnchor" class="button-text" :href="href" :target="target" v-bind="$attrs">
    <slot />
  </a>
  <RouterLink v-else-if="to" :class="$style.linkAnchor" class="button-text" :to="routerLinkTo" v-bind="$attrs">
    <slot />
  </RouterLink>
  <span v-else :class="$style.noLink">
    <slot />
  </span>
</template>

<style lang="scss" module>
@import '@design';

.linkAnchor {
  color: $dark-gray;
  text-decoration: underline;

  &:hover {
    color: $darkest-gray;
  }
}

.noLink {
  display: contents;
}
</style>
